export const formatearRangoFechas = (
  fechaDesde?: string | null,
  fechaHasta?: string | null
): string => {
  if (!fechaDesde) return '26 y 27 de Noviembre 2026';
  const desde = new Date(fechaDesde);
  const hasta = fechaHasta ? new Date(fechaHasta) : desde;

  const diaDesde = desde.getDate();
  const diaHasta = hasta.getDate();
  const anio = desde.getFullYear();
  const mesNombre = desde.toLocaleDateString('es-AR', { month: 'long' });
  const mesCapitalizado = mesNombre.charAt(0).toUpperCase() + mesNombre.slice(1);

  if (diaDesde === diaHasta) {
    return `${diaDesde} de ${mesCapitalizado} ${anio}`;
  }
  return `${diaDesde} y ${diaHasta} de ${mesCapitalizado} ${anio}`;
};
